import { Product, Promo } from '../../types';
import getProductsPrice from '../getProductsPrice';
import { precisionRound, propOr } from '../../utils';

interface Props {
  products?: ReadonlyArray<Partial<Product>>;
  promo?: Promo;
}

const getSafeAmount = propOr(0, 'amount');

const getPromoDiscount = (props?: Props): number => {
  if (!props) {
    return 0;
  }
  const { products, promo } = props;
  let promoDiscount = 0;
  if (promo) {
    const totalPrice = getProductsPrice(products);
    promoDiscount = Math.max(0, totalPrice - getSafeAmount(promo));
  }
  return precisionRound(promoDiscount);
}

export default getPromoDiscount;
